import { FC, ReactNode } from 'react';
import { InViewHookResponse, useInView } from 'react-intersection-observer';
interface LazyBlockProps {
  children: (props: InViewHookResponse) => ReactNode;
}
export const LazyBlock: FC<LazyBlockProps> = ({
  children
}) => {
  const response = useInView({
    threshold: 0,
    triggerOnce: true
  });
  return children(response);
};